import {API} from "@/env";
import Vuex from "@/store";
import axios from "axios";

export default {
    /**
     * GET NOTIFICATION
     * @api {GET} api/web/getNotifications
     **/
   get_notification() {
        const options = {
            method: 'GET',
            url: API + 'api/web/getNotifications',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * DELETE NOTIFICATION
     * @api {POST} api/web/getNotifications
     **/
    delete_notification(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/deleteNotification',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error)
            })
        })
    },
}